export default "__VITE_ASSET__BIfichAs__"